'use strict';

(function () {
    'use strict';

    angular.module('zp').controller('resultsController', resultsController);

    /** @ngInject */
    function resultsController($window, $q, $rootScope, $state, $location, scrollToService, SearchModel, ResultModel, searchBackgroundConfig, SearchService, LoaderService, $timeout, vendorsService, orderByFilter, searchFiltersConfig, $uibModal, authService, notify, SlugerService, config, GeolocationService) {

        var vm = this;
        var _originalResults = [];
        var _originalNonRecomendations = [];
        var resultsGrid = null;
        var cities = [];

        // vm.vendors = [[], [], []];
        vm.showVendors = false;
        vm.recomendations = [];
        vm.nonRecomendations = [];
        // vm.filtered = []
        vm.searchInProgress = false;
        vm.showResults = false;

        vm.configFilter = {
            resolution: 767,
            opened: false
        };

        vm.filters = null;

        vm.filterActive = false;
        vm.carrier = null;
        vm.nextImage = nextImage;
        vm.previousImage = previousImage;

        vm.toggleResults = toggleResults;
        vm.filterResults = filterResults;
        vm.openVendor = openVendor;
        vm.filterInProgress = false;
        vm.filtersCollapsed = $window.innerWidth < 768;;
        vm.grid = null;

        vm.selectVendor = selectVendor;
        vm.sanitizeVendor = sanitizeVendor;

        vm.loadMoreResults = loadMoreResults;
        vm.searchAll = searchAll;
        vm.onGalleryClicked = onGalleryClicked;
        vm.addToFavourite = addToFavourite;
        vm.like = like;
        vm.isVendorFavourited = isVendorFavourited;

        /////////////////////////////////////////////

        (function () {
            if (!$rootScope.searchAreaBackground) {
                $rootScope.searchAreaBackground = searchBackgroundConfig['default'];
                $rootScope.searchAreaOpacity = 1;
            }
            $location.hash('');
            $rootScope.$on('filters:changed', function (event, data) {
                filterResults(data);
            });
            angular.element($window).bind('resize', function () {
                vm.filtersCollapsed = $window.innerWidth < 768;
            });
            // loadGridConfig()
            loadCities().then(loadFilters).then(startSearch).then(loadSearchModel).then(loadGridConfig).then(loadResults).then(loadRecommendations).then(stopSearch);
        })();

        /////////////////////////////////////////////

        function loadCities() {
            return SearchService.getCities().then(function (c) {
                var allCities = c.find(function (cit) {
                    return cit.address === 'svi';
                });
                var index = -1;
                if (allCities) {
                    index = c.indexOf(allCities);
                }
                for (var i = 0; i < c.length; i++) {
                    if (i != index) {
                        cities.push(c[i]);
                    }
                }
                if (allCities) {
                    cities.push(allCities);
                }
            });
        }

        function loadGridConfig() {
            if (config.useGoogleAutocomplete) {
                return vendorsService.getGridConfig().then(function (config) {
                    resultsGrid = config;
                    vm.grid = resultsGrid[$state.params.vendor] ? resultsGrid[$state.params.vendor] : resultsGrid.general;
                });
            } else {
                return vendorsService.getGridConfig(vm.searchModel.city, $state.params.vendor).then(function (config) {
                    resultsGrid = config;
                    vm.grid = resultsGrid[$state.params.vendor] ? resultsGrid[$state.params.vendor] : resultsGrid.general;
                });
            }
        }

        function loadFilters() {
            return $q.when(function () {
                vm.filters = new searchFiltersConfig()[$state.params.vendor];
                var locationFilter = vm.filters.find(function (f) {
                    return f.alias === 'location';
                });
                if (locationFilter && !config.useGoogleAutocomplete) {
                    locationFilter.match = 'contains';
                    locationFilter.control = 'dropdown';
                    locationFilter.options = cities.map(function (c) {
                        return c.name;
                    });
                    locationFilter.values = cities;
                }
            }());
        }

        function searchAll() {
            _originalResults = [];
            _originalNonRecomendations = [];
            vm.recomendations = [];
            vm.nonRecomendations = [];
            vm.searchModel.city = null;
            startSearch().then(loadSearchModel).then(loadGridConfig).then(function () {
                return loadResults(true);
            }).then(loadRecommendations).then(function () {
                vm.showResults = true;
            }).then(stopSearch);
        }

        function loadResults(excludeGeolocation) {
            vm.searchInProgress = true;
            vm.searchModel.selectedCategory = getVendorName($state.params.vendor);
            var searchPromise;
            if (excludeGeolocation) {
                searchPromise = vendorsService.getVendors($state.params.vendor);
            } else {
                searchPromise = vendorsService.getVendors($state.params.vendor, vm.searchModel.latitude, vm.searchModel.longitude, vm.searchModel.radius);
            }
            return searchPromise.then(function (res) {
                _originalResults = orderByFilter(res, 'images', true);
                var min = Math.min([res.length, 7]);
                for (var i = 0; i < min; i++) {
                    _originalResults[i].stickers.push({
                        name: 'discount',
                        label: 'Popust ' + (i + 1) * 10 + '%'
                    });
                }
            });
        }

        function getVendorName(vendor) {
            return vendor == 'vencanice' ? 'venčanice' : vendor == 'dekoracija-cvece' ? 'cveće' : vendor;
        }

        function selectVendor(vendor) {
            vm.searchModel.selectedCategory = getVendorName(vendor);
            $state.go('nav.results', { vendor: vendor });
        }

        function sanitizeVendor(vendor) {
            return vendor.replace(/ /g, '-').toLowerCase();
        }

        function loadSearchModel() {
            return SearchService.getSearchModel().then(function (s) {
                vm.searchModel = s;
                var locationFilter = vm.filters.find(function (f) {
                    return f.alias === 'location';
                });
                if (!config.useGoogleAutocomplete && locationFilter) {
                    setNearestCityIfAlreadyNotSet(locationFilter);
                }
            });
        }

        function setNearestCityIfAlreadyNotSet(locationFilter) {
            if ($state.params.city) {
                var city = cities.find(function (c) {
                    return c.address === $state.params.city;
                });
                vm.searchModel.latitude = city.latitude;
                vm.searchModel.longitude = city.longitude;
                vm.searchModel.radius = city.radius;
                vm.searchModel.city = city.address;
                vm.searchModel.locationLabel = city.name;
                vm.searchModel['location_label'] = city.name;
            } else if (!vm.searchModel.latitude || !vm.searchModel.longitude) {
                for (var i = 0; i < cities.length; i++) {
                    cities[i].distance = GeolocationService.getGeoDistance(cities[i].latitude, cities[i].longitude, $rootScope.currentLocation.latitude, $rootScope.currentLocation.longitude);
                }
                var orderedCities = orderByFilter(cities, 'distance');
                vm.searchModel.latitude = orderedCities[0].latitude;
                vm.searchModel.longitude = orderedCities[0].longitude;
                vm.searchModel.radius = orderedCities[0].radius;
                vm.searchModel.city = orderedCities[0].address;
                vm.searchModel.locationLabel = orderedCities[0].name;
                vm.searchModel['location_label'] = orderedCities[0].name;
            }
            locationFilter.defaultLabel = vm.searchModel.locationLabel;
        }

        function startSearch() {
            return $q.when(function () {
                vm.searchInProgress = true;
                return LoaderService.start();
            }());
        }

        function stopSearch() {
            return $q.when(function () {
                vm.searchInProgress = false;
                return LoaderService.stop();
            }());
        }

        function openVendor(vendor, event) {
            if (!vm.galleryClicked || vm.galleryClicked.originalEvent.target.className !== 'glyphicon glyphicon-chevron-right' && vm.galleryClicked.originalEvent.target.className !== 'glyphicon glyphicon-chevron-left') {
                var url = $state.href('nav.vendor-slug', { vendor: $state.params.vendor, slugCity: SlugerService.generateSlug(vendor.city), slugName: SlugerService.generateSlug(vendor.name) });
                window.open(url, '_blank');
            }
            vm.galleryClicked = false;
        }

        function onGalleryClicked(event) {
            vm.galleryClicked = event;
        }

        function loadRecommendations() {
            return $q.when(function () {
                var number = 4;

                number = $window.innerWidth > resultsGrid.limit ? vm.grid.gt : vm.grid.lt;
                for (var i = 0; i < _originalResults.length; i++) {
                    var resModel = new ResultModel(_originalResults[i]);
                    if (i === 0 && vm.grid.useCarrier) {
                        if (vm.grid.carrier) {
                            vm.carrier = getCarrier(_originalResults, vm.grid.carrier);
                            if (vm.carrier.id !== resModel.id) {
                                vm.recomendations.push(resModel);
                            }
                        } else {
                            vm.carrier = resModel;
                        }
                        continue;
                    }
                    var count = vm.recomendations.length;
                    count += vm.carrier ? 1 : 0;
                    if (count < number && (!vm.grid.recomended.length || vm.grid.recomended.indexOf(resModel.id) !== -1) && (!vm.carrier || vm.carrier.id !== resModel.id)) {
                        vm.recomendations.push(resModel);
                    } else {
                        _originalNonRecomendations.push(resModel);
                    }
                }
                var finalCount = vm.recomendations.length;
                finalCount += vm.carrier ? 1 : 0;
                if (finalCount < number) {
                    var fillIn = _originalNonRecomendations.splice(0, number - finalCount);
                    for (var i = 0; i < fillIn.length; i++) {
                        vm.recomendations.push(fillIn[i]);
                    }
                }
            }());
        }

        function getCarrier(results, carrierId) {
            return results.find(function (r) {
                return r.id === carrierId;
            });
        }

        function toggleResults(noScroll) {
            if (!vm.showResults) {
                vm.sowingResultsInProgress = true;
                vm.showResults = true;
                vm.nonRecomendations = [];
                var limit = Math.min(_originalNonRecomendations.length, 12);
                for (var i = 0; i < limit; i++) {
                    vm.nonRecomendations.push(_originalNonRecomendations[i]);
                }
                $timeout(function () {
                    if (!noScroll) {
                        $location.hash('vendor-results');
                        scrollToService.scrollTo('vendor-results');
                    }
                    vm.sowingResultsInProgress = false;
                }, 500);
            } else {
                if (!noScroll) {
                    $location.hash('vendor-results');
                    scrollToService.scrollTo('vendor-results');
                }
                vm.sowingResultsInProgress = false;
            }
        }

        function loadMoreResults() {
            var from = vm.nonRecomendations.length;
            if (!vm.filters) {
                return;
            }
            var onlyFilters = vm.filters.filter(function (f) {
                return f.filter;
            });
            var filteredVendors = _originalNonRecomendations.filter(function (v) {
                return v.match(onlyFilters);
            });
            var limit = Math.min(filteredVendors.length, from + 3);
            for (var i = from; i < limit; i++) {
                vm.nonRecomendations.push(filteredVendors[i]);
            }
        }

        function applySearchFilter(filter) {
            switch (filter.alias) {
                case 'location':
                    vm.searchModel.latitude = filter.selectedValue.latitude;
                    vm.searchModel.longitude = filter.selectedValue.longitude;
                    vm.searchModel.city = filter.selectedValue.address;
                    vm.searchModel.radius = filter.selectedValue.radius;
                    vm.searchModel.locationLabel = filter.selectedValue.name;
                    break;
            }
        }

        var lastSearchValue = null;
        function filterResults(filters) {
            vm.filtersApplied = true;
            var searchFilters = filters.filter(function (f) {
                return f.search && f.selectedValue && !isEmpty(f.selectedValue);
            });
            if (searchFilters && searchFilters.length && searchFilters[0].selectedValue !== lastSearchValue) {
                for (var i = 0; i < searchFilters.length; i++) {
                    lastSearchValue = searchFilters[i].selectedValue;
                    applySearchFilter(searchFilters[i]);
                    $rootScope.$broadcast('filters:reset', { alias: 'search' });
                }
                _originalResults = [];
                vm.recomendations = [];
                _originalNonRecomendations = [];
                vm.nonRecomendations = [];
                vm.showResults = false;
                vm.hideCarrriers = false;
                vm.carrier = null;

                return startSearch().then(loadSearchModel).then(loadGridConfig).then(loadResults).then(loadRecommendations).then(function () {
                    return applyFilters(filters);
                })
                //.then(stopSearch)
                .then(function () {
                    $timeout(function () {
                        // $location.hash('vendor-results');
                        // scrollToService.scrollTo('vendor-results');
                        vm.sowingResultsInProgress = false;
                        stopSearch();
                    }, 600);
                });
            }
            var textFilter = filters.find(function (f) {
                return f.name === 'Pretraga';
            });
            vm.hideCarrriers = !!textFilter && !!textFilter.selectedValue;
            applyFilters(filters, vm.hideCarrriers);
        }

        function applyFilters(filters, includeRecommendations) {
            var onlyFilters = filters.filter(function (f) {
                return f.filter;
            });
            vm.filterInProgress = true;
            vm.showResults = true;
            vm.nonRecomendations = [];
            if (includeRecommendations) {
                for (var i = 0; i < _originalResults.length; i++) {
                    if (vm.nonRecomendations.length > 12) {
                        break;
                    }
                    var resM = new ResultModel(_originalResults[i]);
                    if (resM.match(onlyFilters)) {
                        vm.nonRecomendations.push(resM);
                    }
                }
            } else {
                for (var i = 0; i < _originalNonRecomendations.length; i++) {
                    if (vm.nonRecomendations.length > 12) {
                        break;
                    }
                    if (_originalNonRecomendations[i].match(onlyFilters)) {
                        vm.nonRecomendations.push(_originalNonRecomendations[i]);
                    }
                }
            }
            vm.showResults = true;
            vm.filterInProgress = false;
        }

        function isEmpty(obj) {
            for (var key in obj) {
                if (obj.hasOwnProperty(key)) return false;
            }
            return true;
        }

        function nextImage(item) {
            if (!item.images || !item.images.length) {
                return false;
            }
            var imagesSize = item.images.length;
            var currentIndex = !!item.imageIndex ? item.imageIndex : 0;
            if (currentIndex < imagesSize - 1) {
                currentIndex++;
            } else {
                currentIndex = 0;
            }
            item.image = item.images[currentIndex].url;
            item.imageIndex = currentIndex;
        }

        function previousImage(item) {
            if (!item.images || !item.images.length) {
                return false;
            }
            var imagesSize = item.images.length;
            var currentIndex = !!item.imageIndex ? item.imageIndex : 0;
            if (currentIndex > 0) {
                currentIndex--;
            } else {
                currentIndex = imagesSize - 1;
            }
            item.image = item.images[currentIndex].url;
            item.imageIndex = currentIndex;
        }

        function addToFavourite(resultItem) {
            return tryToLoginUser('Da bi ste dodali u Vaš MIX potrebno je ra se Prijavite, tj da se Registrujete ukoliko već nemate nalog.').then(function () {
                if (isVendorFavourited(resultItem)) {
                    return $q.reject(resultItem.name + ' se već nalazi u Vašem MIX-u');
                }
                var user = $rootScope.currentUser;
                if (!user.favourites[resultItem.category]) {
                    user.favourites[resultItem.category] = [];
                }
                user.favourites[resultItem.category].push(resultItem.id);
                return authService.update(user);
            }).then(function () {
                return vendorsService.favourite(resultItem, resultItem.category);
            }).then(function (response) {
                resultItem.favsCount = response.favsCount;
            }).catch(function (err) {
                notify({ message: err, classes: ['warning'], position: 'right' });
            });
        }

        function like(resultItem) {
            return vendorsService.like(resultItem, resultItem.category).then(function (response) {
                resultItem.likeCount = response.likeCount;
            }).catch(function (err) {
                notify({ message: err, classes: ['error'], position: 'right' });
            });
        }

        function isVendorFavourited(vendor) {
            if (!vendor) {
                return false;
            }
            return $rootScope.currentUser && $rootScope.currentUser.favourites && $rootScope.currentUser.favourites[vendor.category] && $rootScope.currentUser.favourites[vendor.category].indexOf(vendor.id) !== -1;
        }

        function tryToLoginUser(text) {
            if ($rootScope.currentUser) {
                return $q.when(function () {
                    return true;
                }());
            }
            var defered = $q.defer();
            $uibModal.open({
                animation: true,
                templateUrl: 'app/auth/auth.login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    options: function options() {
                        return {
                            text: text
                        };
                    }
                }
            }).result.then(function (success) {
                if (success) {
                    defered.resolve();
                } else {
                    defered.reject();
                }
            });
            return defered.promise;
        }
    }
})();